import React from 'react';
import compose from 'recompose/compose';
import classnames from 'classnames';
import { arrayOf, shape, string, number } from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import {connect} from 'react-redux';
import { withStyles } from 'material-ui/styles';
import Stackup from '../../common/Stackup';
import Scene from '../../common/Scene';
import MaterialViewer from '../Viewer/MaterialsViewer';
import ResultViewer from '../Viewer/ResultViewer';
import {
  getStackupLayers,
  getStackupToExport,
  getCopperCount,
  getPressedThickness,
  getTotalThickness,
  getLengthUnit
} from '../../../reducers';
import { stackupLayerPropType, stackupPropType } from '../../../lib/shapes';
import { inchToString } from '../../../lib/unitConversions';
import Actions from './Actions';
import RequestQuoteDialog from './RequestQuoteDialog';

const styles = (theme) => ({
  root: {
    margin: theme.spacing.unit * 3,
  },
  pageBreak: {
    margin: theme.spacing.unit * 2,
  },
  actionBottom: {
    marginTop: theme.spacing.unit * 3,
  },
  actionTop: {
    marginBottom: theme.spacing.unit * 3,
  },
  reportTop: {
    display: 'flex',
    alignItems: 'center',
  },
  image: {
    width: '40%'
  },
  specs: {
    display: 'flex',
    width: '60%',
    '& dl': {
      float: 'left',
      width: 500,
      margin: theme.spacing.unit *1,
      padding: 0,
      borderBottom: '1px solid #999',
    },
    '& dt': {
      clear: 'left',
      float: 'left',
      width: 200,
      margin: 0,
      padding: 5,
      borderTop: '1px solid #999',
      fontWeight: 'bold'
    },
    '& dd': {
      float: 'left',
      width: 'calc(500px - 200px)',
      margin: 0,
      padding: 5,
      borderTop: '1px solid #999',
    }
  },
  '@media print': {
    root: {
      margin: 0,
      marginTop: theme.spacing.unit * 3,
      size: 'landscape'
    },
    pageBreak: {
      pageBreakAfter: 'always'
    },
    marginTop: {
      marginTop: 64 + theme.spacing.unit * 3,
    },
    table: {
      pageBreakInside: 'avoid',
    }
  }
})

export class Report extends React.Component {
  constructor(props) {
    super(props);
    this.onCancel = this.onCancel.bind(this);
    this.onPrint = this.onPrint.bind(this);
    this.onRequestQuote = this.onRequestQuote.bind(this);
    this.closeQuoteDialog = this.closeQuoteDialog.bind(this);
  }

  onCancel() {
    const { history } = this.props;
    const { from } = (history.location && history.location.state) || {};
    if (from) {
      history.push(from);
    } else {
      history.push('/app');
    }
  }

  onPrint() {
    window.print();
  }

  onRequestQuote() {
    const { history } = this.props;
    history.push('?quote=true');
  }

  closeQuoteDialog() {
    const { history, match } = this.props;
    history.push(match.path);
  }

  render() {
    const {
      stackup,
      layers,
      location,
      classes,
      totalThickness,
      pressedThickness,
      lengthUnit
    } = this.props;
    const { name, partNumber, type } = stackup;
    const search = new URLSearchParams(location.search)

    return (
      <div className={classes.root}>
        <RequestQuoteDialog
          open={Boolean(search.get('quote'))}
          onClose={this.closeQuoteDialog}
        />
        <Actions
          className={classes.actionTop}
          onCancel={this.onCancel}
          onPrint={this.onPrint}
          onRequestQuote={this.onRequestQuote}
        />
        <div className={classes.reportTop}>
          <div className={classes.image}>
            <Scene width={300} height={200}>
              <Stackup layers={layers} freezeMouseEvents />
            </Scene>
          </div>
          <div className={classes.specs}>
            <dl>
              <dt>Project Name</dt>
              <dd>{name}</dd>
              <dt>Part Number</dt>
              <dd>{partNumber}</dd>
              <dt>Type of Stackup</dt>
              <dd>{type}</dd>
              <dt>Initial Thickness</dt>
              <dd>
                {totalThickness ? inchToString(totalThickness, lengthUnit) : 'N/A'}
              </dd>
              <dt>Pressed Thickness</dt>
              <dd>
                {pressedThickness ? inchToString(pressedThickness, lengthUnit) : 'N/A'}
              </dd>
            </dl>
          </div>
        </div>

        <div className={classes.table}>
          <ResultViewer print />
        </div>

        <div className={classes.pageBreak} />

        <div className={classnames(classes.table, classes.marginTop)}>
          <MaterialViewer print />
        </div>
        <Actions
          className={classes.actionBottom}
          onCancel={this.onCancel}
          onPrint={this.onPrint}
          onRequestQuote={this.onRequestQuote}
        />
      </div>
    );
  }
}

function mapStateToProps(state){
  return {
    stackup: getStackupToExport(state),
    layers: getStackupLayers(state),
    copperCount: getCopperCount(state),
    pressedThickness: getPressedThickness(state),
    totalThickness: getTotalThickness(state),
    lengthUnit: getLengthUnit(state),
  };
}

Report.propTypes = {
  classes: shape({
    root: string,
    pageBreak: string,
    dlTableDisplay: string,
    specs: string,
    reportTop: string
  }).isRequired,
  layers: arrayOf(shape(stackupLayerPropType)).isRequired,
  stackup: shape(stackupPropType).isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  location: ReactRouterPropTypes.location.isRequired,
  match: ReactRouterPropTypes.match.isRequired,
  totalThickness: number.isRequired,
  pressedThickness: number.isRequired,
  lengthUnit: string.isRequired,
};

export default compose(
  connect(mapStateToProps),
  withStyles(styles)
)(Report);



// WEBPACK FOOTER //
// ./src/components/StackupDesign/Report/Report.jsx